(function () {
  var storageKey = 'rpm-theme';

  function getSystemTheme() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function getStoredTheme() {
    try {
      return localStorage.getItem(storageKey);
    } catch (e) {
      return null;
    }
  }

  function applyTheme(theme, persist) {
    var next = theme === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', next);
    if (persist) {
      try {
        localStorage.setItem(storageKey, next);
      } catch (e) {}
    }
    return next;
  }

  function initTheme() {
    var stored = getStoredTheme();
    applyTheme(stored || getSystemTheme(), false);
  }

  window.rpmSetTheme = function (theme) {
    return applyTheme(theme, true);
  };

  window.rpmToggleTheme = function () {
    var current = document.documentElement.getAttribute('data-theme') || getSystemTheme();
    return applyTheme(current === 'dark' ? 'light' : 'dark', true);
  };

  initTheme();

  if (window.matchMedia) {
    var media = window.matchMedia('(prefers-color-scheme: dark)');
    var onThemeChange = function () {
      if (!getStoredTheme()) {
        applyTheme(getSystemTheme(), false);
      }
    };
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', onThemeChange);
    } else if (typeof media.addListener === 'function') {
      media.addListener(onThemeChange);
    }
  }
})();


(function () {
  var garageKey = 'rpm-garaje-v2';
  var currentVehicleKey = 'rpm_selected_vehicle';

  function safeParse(value, fallback) {
    try {
      var parsed = JSON.parse(value);
      return parsed == null ? fallback : parsed;
    } catch (e) {
      return fallback;
    }
  }

  function normalizeText(value) {
    return String(value == null ? '' : value).trim();
  }
  function visibleTypeLabel(value) {
    var raw = normalizeText(value);
    if (!raw || raw.indexOf('|') === -1) return raw;
    var parts = raw.split('|');
    var left = normalizeText(parts[0]);
    var right = normalizeText(parts.slice(1).join('|'));
    if (left && right && left.length <= 12) return right;
    return raw;
  }

  function slug(value) {
    return normalizeText(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  function normalizeVehicle(vehicle) {
    var normalized = {
      marca: normalizeText(vehicle && (vehicle.marca || vehicle.Marca || vehicle.brand)),
      modelo: normalizeText(vehicle && (vehicle.modelo || vehicle.Modelo || vehicle.model)),
      generacion: normalizeText(vehicle && (vehicle.generacion || vehicle.Generacion || vehicle.generation || vehicle.anyo || vehicle.year)),
      version: normalizeText(vehicle && (vehicle.version || vehicle.Version || vehicle.nombre || vehicle.Nombre || vehicle.motor)),
      categoria: normalizeText(vehicle && (vehicle.categoria || vehicle.category)),
      subcategoria: visibleTypeLabel(vehicle && (vehicle.subcategoria || vehicle.type)),
      q: normalizeText(vehicle && vehicle.q),
      url: normalizeText(vehicle && (vehicle.url || vehicle.href || vehicle.link)),
      image: normalizeText(vehicle && (vehicle.image || vehicle.imagen)),
      title: normalizeText(vehicle && vehicle.title),
      savedAt: normalizeText(vehicle && (vehicle.savedAt || vehicle.fecha)) || new Date().toISOString()
    };
    var categories = [];
    [normalized.categoria, normalized.subcategoria].forEach(function (value) {
      if (value && categories.indexOf(value) === -1) categories.push(value);
    });
    normalized.categories = categories;
    normalized.id = [slug(normalized.marca), slug(normalized.modelo), slug(normalized.generacion), slug(normalized.version), slug(normalized.categoria), slug(normalized.subcategoria), slug(normalized.q)].filter(Boolean).join('|');
    return normalized;
  }

  function readGarage() {
    try {
      var raw = localStorage.getItem(garageKey);
      var items = safeParse(raw || '[]', []);
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function writeGarage(items) {
    try {
      localStorage.setItem(garageKey, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('rpm:garage:change', { detail: { items: items } }));
  }

  function setCurrentVehicle(vehicle) {
    var normalized = normalizeVehicle(vehicle || {});
    try {
      localStorage.setItem(currentVehicleKey, JSON.stringify(normalized));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('rpm:vehicle:current', { detail: { vehicle: normalized } }));
    return normalized;
  }

  function getCurrentVehicle() {
    try {
      return normalizeVehicle(safeParse(localStorage.getItem(currentVehicleKey) || '{}', {}));
    } catch (e) {
      return normalizeVehicle({});
    }
  }

  function addToGarage(vehicle) {
    var normalized = normalizeVehicle(vehicle || {});
    /* Allow saving with any non-empty selection (marca, modelo, version, categoria, subcategoria, q) */
    if (!normalized.marca && !normalized.modelo && !normalized.version && !normalized.categoria && !normalized.subcategoria && !normalized.q) return false;
    var items = readGarage();
    var exists = normalized.id && items.some(function (item) { return item.id === normalized.id; });
    setCurrentVehicle(normalized);
    if (!exists) {
      items.unshift(normalized);
      writeGarage(items);
      return true;
    }
    return false;
  }

  function removeFromGarage(id) {
    var wanted = normalizeText(id);
    if (!wanted) return;
    var next = readGarage().filter(function (item) { return normalizeText(item.id) !== wanted; });
    writeGarage(next);
  }

  window.rpmGarage = {
    key: garageKey,
    currentKey: currentVehicleKey,
    getItems: readGarage,
    add: addToGarage,
    remove: removeFromGarage,
    setCurrent: setCurrentVehicle,
    getCurrent: getCurrentVehicle,
    normalize: normalizeVehicle,
    count: function () { return readGarage().length; }
  };
})();


(function () {
  var wishlistKey = 'rpm-wishlist-v1';

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return [];
    }
  }

  function readWishlist() {
    try {
      var raw = localStorage.getItem(wishlistKey);
      var items = safeParse(raw || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('rpm:wishlist:change', { detail: { items: items } }));
  }

  function normalizeId(value) {
    return String(value == null ? '' : value).trim();
  }

  function normalizeText(value) {
    return String(value == null ? '' : value).trim();
  }

  function isRpmPlaceholderImage(value) {
    var src = normalizeText(value).toLowerCase();
    if (!src) return false;
    src = src.split('?')[0].split('#')[0];
    return (
      src.indexOf('rpm-placeholder-engine-red-cloth') !== -1 ||
      src.indexOf('placeholder-engine-red-cloth') !== -1 ||
      src.indexOf('engine-red-cloth') !== -1 ||
      src.indexOf('rpm-placeholder') !== -1
    );
  }

  function normalizeWishlistImage(value) {
    var src = normalizeText(value);
    return isRpmPlaceholderImage(src) ? '' : src;
  }

  function visibleTypeLabel(value) {
    var raw = normalizeText(value);
    if (!raw || raw.indexOf('|') === -1) return raw;
    var parts = raw.split('|');
    var left = normalizeText(parts[0]);
    var right = normalizeText(parts.slice(1).join('|'));
    if (left && right && left.length <= 12) return right;
    return raw;
  }

  function normalizeItem(item) {
    /* available: por defecto true si no viene; "false"/"0" → false */
    var availRaw = item.available;
    var availParsed = true;
    if (availRaw === false || availRaw === 'false' || availRaw === '0' || availRaw === 0) {
      availParsed = false;
    }
    /* Si no está disponible, vaciamos variantId para que la rama
       "sin variant → WhatsApp" se active sin depender del campo available */
    var vid = normalizeText(item.variantId);
    if (!availParsed) vid = '';
    return {
      id: normalizeId(item.id),
      url: normalizeText(item.url),
      title: normalizeText(item.title),
      image: normalizeWishlistImage(item.image),
      price: normalizeText(item.price),
      variantId: vid,
      category: normalizeText(item.category),
      type: visibleTypeLabel(item.type),
      condition: normalizeText(item.condition),
      available: availParsed
    };
  }

  function hasItem(productId) {
    var wanted = normalizeId(productId);
    if (!wanted) return false;
    return readWishlist().some(function (item) { return normalizeId(item.id) === wanted; });
  }

  function toggleItem(item) {
    var normalized = normalizeItem(item || {});
    if (!normalized.id) return false;
    var items = readWishlist();
    var index = items.findIndex(function (entry) { return normalizeId(entry.id) === normalized.id; });
    var added = index === -1;
    if (added) items.unshift(normalized);
    else items.splice(index, 1);
    writeWishlist(items);
    return added;
  }

  function itemFromButton(button) {
    return normalizeItem({
      id: button.getAttribute('data-product-id') || button.getAttribute('data-rpm-wishlist-product-id'),
      url: button.getAttribute('data-product-url'),
      title: button.getAttribute('data-product-title'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price'),
      variantId: button.getAttribute('data-product-variant-id'),
      category: button.getAttribute('data-product-category'),
      type: button.getAttribute('data-product-type'),
      condition: button.getAttribute('data-product-condition'),
      available: button.getAttribute('data-product-available')
    });
  }

  function updateButton(button) {
    if (!button) return;
    var productId = button.getAttribute('data-product-id') || button.getAttribute('data-rpm-wishlist-product-id');
    var active = hasItem(productId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('title', active ? 'Quitar de guardados' : 'Guardar producto');
    button.setAttribute('aria-label', active ? 'Quitar de guardados' : 'Guardar producto');

    var label = button.querySelector('[data-rpm-wishlist-label]');
    if (label) label.textContent = active ? 'Guardado' : 'Guardar';
  }

  function syncButtons(scope) {
    (scope || document).querySelectorAll('[data-rpm-wishlist-btn]').forEach(updateButton);
  }

  function normalizeWishlistEuroAmount(num, original) {
    if (!Number.isFinite(num)) return NaN;
    var raw = String(original == null ? '' : original).trim();
    var compact = raw.replace(/\s+/g, '').replace(/€/g, '').replace(/EUR/ig, '');
    var hasDecimalComma = /,\d{1,2}$/.test(compact);
    var hasDecimalDot = /\.\d{1,2}$/.test(compact) && compact.indexOf(',') === -1;
    var hasAnyDecimal = hasDecimalComma || hasDecimalDot;

    /*
      Shopify normally stores money in cents on data attributes (29900 = 299,00 €).
      Saved wishlist items can also contain already formatted euro strings (299,00 €).
      If the parsed value is too large and there is no clear decimal separator, treat it as cents.
      This fixes cases like 29900 -> 299 instead of discounting 29.900 €.
    */
    if (!hasAnyDecimal && Math.abs(num) >= 10000) return num / 100;
    return num;
  }

  function parseMoneyNumber(value) {
    if (value == null) return NaN;
    var original = String(value).trim();
    if (!original) return NaN;

    var str = original.replace(/\s+/g, '').replace(/€/g, '').replace(/EUR/ig, '');
    if (!str) return NaN;

    if (str.indexOf(',') !== -1 && str.indexOf('.') !== -1) {
      if (str.lastIndexOf(',') > str.lastIndexOf('.')) str = str.replace(/\./g, '').replace(',', '.');
      else str = str.replace(/,/g, '');
    } else if (str.indexOf(',') !== -1) {
      str = str.replace(/\./g, '').replace(',', '.');
    } else if (str.indexOf('.') !== -1) {
      /* Formato español sin decimales: 1.090 € = 1090 €, no 1,09 €. */
      var dotParts = str.split('.');
      var lastPart = dotParts[dotParts.length - 1];
      if (dotParts.length > 1 && /^\d{3}$/.test(lastPart)) {
        str = dotParts.join('');
      }
    }

    var num = Number(str);
    if (!Number.isFinite(num)) return NaN;
    return normalizeWishlistEuroAmount(num, original);
  }

  function formatMoneyString(value) {
    if (value == null) return '';
    var num = typeof value === 'number' ? value : parseMoneyNumber(value);
    if (!Number.isFinite(num)) {
      var str = String(value).trim();
      return str || '';
    }
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(num);
    } catch (e) {
      return String(Math.round(num * 100) / 100).replace('.', ',') + ' €';
    }
  }

  function getWishlistB2BPercent() {
    var cfg = window.rpmCustomerPricing || {};
    var pct = Number(cfg.wishlistB2bPct || 0);
    return Number.isFinite(pct) && pct > 0 ? pct : 0;
  }

  function countLabels() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-rpm-wishlist-count]').forEach(function (node) {
      node.textContent = count;
    });
    document.querySelectorAll('[data-rpm-wishlist-open]').forEach(function (button) {
      button.classList.toggle('is-active', count > 0);
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  
function renderWishlistViews() {
  var rawItems = readWishlist();
  var items = rawItems.map(function(item){ return normalizeItem(item || {}); });
  var needsRewrite = items.length !== rawItems.length;
  if (!needsRewrite) {
    for (var wi = 0; wi < items.length; wi += 1) {
      var previousImage = rawItems[wi] && rawItems[wi].image ? String(rawItems[wi].image) : '';
      if (items[wi].image !== previousImage || isRpmPlaceholderImage(previousImage)) {
        needsRewrite = true;
        break;
      }
    }
  }
  if (needsRewrite) writeWishlist(items);
  var list = document.querySelector('[data-rpm-wishlist-list]');
  var empty = document.querySelector('[data-rpm-wishlist-empty]');
  countLabels();
  if (!list || !empty) return;

  function mediaHtml(item, categoryCode) {
    var image = normalizeWishlistImage(item.image);
    if (image) {
      return '<span class="rpm-wl-card__media rpm-wl-card__media--image"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.title || 'Producto guardado') + '"></span>';
    }
    return '<span class="rpm-wl-card__media rpm-wl-card__media--icon">' + categoryIcon(categoryCode) + '</span>';
  }

  function visibleTypeLabel(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return '';
    if (raw.indexOf('|') === -1) return raw;
    var parts = raw.split('|');
    return String(parts.slice(1).join('|') || parts[parts.length - 1] || '').trim();
  }

  function categoryLabel(value) {
    var raw = String(value == null ? '' : value).trim();
    var map = {
      MOT: 'Motores',
      TUR: 'Turbos',
      CAJ: 'Cajas de cambio',
      CUL: 'Culatas',
      ELE: 'Eléctrico',
      INY: 'Inyección',
      OPT: 'Óptica',
      ABS: 'Bomba ABS',
      BDI: 'Bloque / distribución',
      BAT: 'Batería'
    };
    return map[raw] || raw || 'Guardado';
  }

  function stateLabel(value) {
    var raw = String(value == null ? '' : value).trim().toUpperCase();
    var map = { NW: 'Nuevo', RC: 'Reconstruido', US: 'Usado', UX: 'Sin garantía' };
    return map[raw] || (raw ? raw : 'Usado');
  }

  function categoryIcon(code) {
    var raw = String(code == null ? '' : code).trim().toUpperCase() || 'DEF';
    return '<span class="rpm-wl-card__cat-ico" data-load-ic="' + escapeHtml(raw) + '" aria-hidden="true"></span>';
  }

  function hydrateWishlistIcons(scope) {
    var box = document.getElementById('rpm-icons-v2');
    if (!box) return;
    (scope || document).querySelectorAll('#rpmWishlistModal [data-load-ic]').forEach(function (el) {
      var code = el.getAttribute('data-load-ic') || 'DEF';
      var src = box.querySelector('[data-ic="' + code + '"]') || box.querySelector('[data-ic="DEF"]');
      if (src) el.innerHTML = src.innerHTML;
    });
  }

  if (!items.length) {
    list.innerHTML = '';
    list.classList.remove('is-scrollable');
    empty.hidden = false;
    return;
  }

  empty.hidden = true;
  list.classList.toggle('is-scrollable', items.length > 3);

  list.innerHTML = items.map(function (item) {
    var title = escapeHtml(item.title || 'Producto guardado');
    var url = escapeHtml(item.url || '#');
    var category = categoryLabel(item.category);
    var categoryEscaped = escapeHtml(category);
    var categoryCode = String(item.category == null ? '' : item.category).trim().toUpperCase();
    var typeLabel = visibleTypeLabel(item.type);
    var typeEscaped = escapeHtml(typeLabel || '');
    var conditionLabel = stateLabel(item.condition);
    var conditionEscaped = escapeHtml(conditionLabel);
    var basePriceNumber = parseMoneyNumber(item.price);
    var b2bPct = getWishlistB2BPercent();
    var hasB2BPrice = b2bPct > 0 && Number.isFinite(basePriceNumber) && basePriceNumber > 0;
    var discountedPrice = hasB2BPrice ? (basePriceNumber - (basePriceNumber * b2bPct / 100)) : NaN;
    var priceHtml = hasB2BPrice
      ? '<div class="rpm-wl-card__price rpm-wl-card__price--b2b"><span class="rpm-wl-card__price-old">' + escapeHtml(formatMoneyString(basePriceNumber)) + '</span><span class="rpm-wl-card__price-current">' + escapeHtml(formatMoneyString(discountedPrice)) + '</span></div>'
      : '<div class="rpm-wl-card__price">' + escapeHtml(formatMoneyString(item.price) || 'Consultar') + '</div>';
    var line = categoryEscaped + (typeLabel ? ' · ' + typeEscaped : '');
    var waOosHref = 'https://wa.me/34610361774?text=' + encodeURIComponent('Hola, quiero pedir esta pieza aunque esté sin stock:\n' + (item.title || '') + '\nhttps://rpmrepuestos.com' + (item.url || ''));
    var waOosSvg = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/></svg>';
    /* Detectar disponibilidad: solo se considera "disponible" si available NO viene como false */
    var isOutOfStock = (item.available === false || item.available === 'false');
    var cartButton = (item.variantId && !isOutOfStock)
      ? '<button type="button" class="rpm-wl-card__cart" data-rpm-wishlist-add data-variant-id="' + escapeHtml(item.variantId) + '" aria-label="Añadir al carrito">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1"></circle><circle cx="18" cy="20" r="1"></circle><path d="M2.5 4H5l2.3 10.2a1 1 0 0 0 1 .8h8.7a1 1 0 0 0 1-.8L20 7H6"></path></svg>'
        + '<span class="visually-hidden">Añadir al carrito</span>'
        + '</button>'
      : '<a class="rpm-wl-card__cart rpm-wl-card__cart--oos" href="' + waOosHref + '" target="_blank" rel="noopener" aria-label="Pedir sin stock por WhatsApp">'
        + waOosSvg
        + '<span class="visually-hidden">Pedir sin stock por WhatsApp</span>'
        + '</a>';
    /* Etiqueta "Sin stock" en el media wrap */
    var outOfStockTag = isOutOfStock
      ? '<span class="rpm-wl-card__oos-tag">Sin stock</span>'
      : '';

    return ''
      + '<article class="rpm-wl-card' + (isOutOfStock ? ' rpm-wl-card--oos' : '') + '">'
      + '  <a class="rpm-wl-card__stretched" href="' + url + '" aria-label="Abrir ficha de ' + title + '"></a>'
      + '  <div class="rpm-wl-card__media-wrap">'
      +       mediaHtml(item, categoryCode)
      +       outOfStockTag
      + '    <button type="button" class="rpm-wl-card__remove" data-rpm-wishlist-remove data-product-id="' + escapeHtml(item.id) + '" aria-label="Quitar de guardados">'
      + '      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>'
      + '    </button>'
      + '  </div>'
      + '  <div class="rpm-wl-card__body">'
      + '    <div class="rpm-wl-card__chips">'
      +        (typeLabel ? '<span class="rpm-wl-card__chip rpm-wl-card__chip--type">' + typeEscaped + '</span>' : '')
      + '      <span class="rpm-wl-card__chip rpm-wl-card__chip--state">' + conditionEscaped + '</span>'
      + '    </div>'
      + '    <h4 class="rpm-wl-card__title">' + title + '</h4>'
      + '    <p class="rpm-wl-card__line">' + line + '</p>'
      + '    <div class="rpm-wl-card__footer">'
      + '      ' + priceHtml
      +        cartButton
      + '    </div>'
      + '  </div>'
      + '</article>';
  }).join('');
  hydrateWishlistIcons(list);
}

window.rpmWishlist = {
    getItems: readWishlist,
    has: hasItem,
    toggle: toggleItem,
    sync: syncButtons,
    render: renderWishlistViews,
    count: function () { return readWishlist().length; }
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-rpm-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      toggleItem({ id: removeButton.getAttribute('data-product-id') });
      syncButtons(document);
      renderWishlistViews();
      return;
    }

    var addButton = event.target.closest('[data-rpm-wishlist-add]');
    if (addButton) {
      event.preventDefault();
      var variantId = addButton.getAttribute('data-variant-id');
      if (variantId && typeof window.rpmAddToCart === 'function') {
        window.rpmAddToCart(addButton, variantId, { defaultText: 'Añadir' });
      }
      return;
    }

    /* Tarjeta clicable sin observadores ni fetches: evita que el contenido bloquee el enlace estirado. */
    var wlCard = event.target.closest('#rpmWishlistModal .rpm-wl-card');
    if (wlCard && !event.target.closest('a, button, input, select, textarea, [role="button"]')) {
      var cardLink = wlCard.querySelector('.rpm-wl-card__stretched[href]');
      if (cardLink && cardLink.getAttribute('href') && cardLink.getAttribute('href') !== '#') {
        event.preventDefault();
        window.location.href = cardLink.getAttribute('href');
      }
      return;
    }

    var button = event.target.closest('[data-rpm-wishlist-btn]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggleItem(itemFromButton(button));
    syncButtons(document);
    renderWishlistViews();
  });

  document.addEventListener('rpm:wishlist:change', function () {
    syncButtons(document);
    renderWishlistViews();
  });

  document.addEventListener('rpm:wishlist:render', function () {
    renderWishlistViews();
  });

  document.addEventListener('shopify:section:load', function (event) {
    syncButtons(event.target);
    renderWishlistViews();
  });

  ready(function () {
    syncButtons(document);
    renderWishlistViews();
  });
})();
